import z from 'zod'

export const shortlistRankingSchema = z.object({
  answers: z.record(z.string(), z.string()).superRefine((answers, context) => {
    for (const [key, answer] of Object.entries(answers)) {
      if (answer !== 'yes' && answer !== 'no') {
        context.addIssue({
          code: 'custom',
          path: [key],
          message: 'Indiquez si vous retenez ce profil ou non'
        })
      }
    }
  }),
  comments: z.record(z.string(), z.string().max(5000))
})

export type ShortlistRankingValues = z.infer<typeof shortlistRankingSchema>

export const lineKey = (lineId: number): string => `line-${lineId}`
